import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    margin: theme.spacing(0.5),
    whiteSpace: 'nowrap',
    height: '24px',
    justifyContent: 'space-between',
    minWidth: '120px',
    border: '1px #20427E33 solid',
  },
}));

export default useStyles;
